import S from './Submit'
import B from './Back'
import B2 from './Back2'
import ST from './styleButton'

export const Submit = S
export const Back = B
export const BackNotBack = B2
export const StyleButton = ST
